import { useContext } from 'react';

import { AppContext } from '../scripts/context'

export default function Scrollbar() {

    const {
    //SCROLL
        scrollbarSliderRef,
    } = useContext(AppContext);

    return (
        <div id="scrollbar">
            <div id="scrollbar_slider" ref={scrollbarSliderRef}></div>
        </div>
    );

};